import React, { useState, useEffect, useCallback } from "react";
import "./design.css";
import { QuestionsList, QuestionTypeList } from "./QuestionsList";
import { TabView, TabPanel } from "primereact/tabview";
import Content from "./Content";
import Settings from "./Settings";
import Button from "../../shared-components/Button/custom-button";
import DetailsContent from "./HeaderDesign/DetailsContent";
import SettingsContent from "./HeaderDesign/SettingsContent";
import FooterSettings from "./FooterDesign/FooterSettings";
import { Dialog } from "primereact/dialog";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DisplayLogic from "./DisplayLogic";
import { useDispatch, useSelector } from "react-redux";
import { createOrUpdateSurveyDefinition } from "./design-store/design-actions";
import { useHistory, useParams } from "react-router-dom";
import {
  checkOnCHangeData,
  fetchCurrentSurveyID,
} from "../ProjectList/home-store/home-actions-creators";
import PageRefreshDialog from "../PageRefresh/PageRefresh";
import {
  validateAllQuestions,
  validateFooter,
  validateHeader,
  validateQuestionsAndOptions,
} from "./Helpers/Validations";
import { loadToaster } from "../../shared-components/toaster/toaster-actions-creators";
import { Checkbox } from "primereact/checkbox";
import { displayTranlslationPage } from "./design-store/design-actions-creators";
import TerminationLogic from "./TerminationLogic";

const Design = () => {
  const [activeEditTab, setActiveEditTab] = useState(0);
  const [activeHeaderEditTab, setActiveHeaderEditTab] = useState(0);
  const [activeQuestion, setActiveQuestion] = useState({
    pageIndex: 0,
    questionIndex: -1,
  });
  const [changes, setChanges] = useState(0);
  const [questionListSize, setQuestionListSize] = useState(0);
  const [random, setRandom] = useState(1);
  const [randomOptionId, setRandomOptionId] = useState(1);
  const [activeHeaderFooter, setActiveHeaderFooter] = useState("header");
  const [currentPage, setCurrentPage] = useState(null);
  const SAVED = "SAVED";
  const ADDED = "ADDED";
  const UPDATED = "UPDATED";
  const OTHER = "OTHER";
  const NONE = "NONE";
  const dispatch = useDispatch();
  const project = useSelector((state) => state.projectList);
  const { currentCode, currentSurveyID, currentSurveyName } = useSelector(
    (state) => state.projectList
  );

  const { userLoginDetails } = useSelector((state) => state.login);
  const { surveyDefinitionData } = useSelector((state) => state.designDetails);
  const { id } = useParams();
  const [error, setError] = useState({});
  const [deletePopUp, setDeletePopUp] = useState(false);
  const [languageDialogBox, setLanguageDialogBox] = useState(false);
  const [mergeQuestions, setMergeQuestions] = useState(false);
  const [tabHeaderFooterData, setTabHeaderFooterData] = useState({});
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [changeDisplayLogic, setChangeDisplayLogic] = useState(false);
  const [isDLDirty, setIsDLDirty] = useState(false);
  // const [activeQuestions, setActiveQuestions] = useState({});
  const history = useHistory();
  const [showJsonModal, setShowJsonModal] = useState(false);
  const [jsonData, setJsonData] = useState("");

  const [cloneQuestionDialog, setCloneQuestionDialog] = useState({
    visible: false,
    questionIndex: null,
    pageIndex: null,
  });

  const [deleteQuestionDialog, setDeleteQuestionDialog] = useState({
    visible: false,
    questionIndex: null,
    pageIndex: null,
  });
  const [hideQuestionDialog, setHideQuestionDialog] = useState({
    visible: false,
    pageIndex: null,
    questionIndex: null,
    hideAction: true, // true => hide, false => unhide
  });
  const handleDLDirtyChange = (dirty) => {
    setIsDLDirty(dirty);
  };
  const handleQuestionClick = (selection) => {
    if (isDLDirty) {
      dispatch(
        loadToaster({
          type: "warn",
          title: "Unsaved Display Logic",
          msg: "Please save display logic before switching.",
        })
      );
      return; // Prevent question change
    }
    setActiveQuestion(selection);
    setCurrentPage(selection.pageIndex);
  };


  useEffect(() => {
    if (Object.keys(surveyDefinitionData).length !== 0) {
      //console.log("Survey Definition Data: ", surveyDefinitionData);
      setTabHeaderFooterData(surveyDefinitionData);
      setSelectedLanguages(surveyDefinitionData?.translations?.languages);
    }
    return () => {
      //console.log("going out")
    };
  }, [surveyDefinitionData]);

  useEffect(() => {
    if (surveyDefinitionData?.translations?.languages) {
      setSelectedLanguages(surveyDefinitionData?.translations.languages);
    }
  }, [surveyDefinitionData?.translations?.languages]);

  useEffect(() => {
    setActiveEditTab(0);
  }, [activeQuestion]);

  useEffect(() => {
    if (
      tabHeaderFooterData.pages &&
      tabHeaderFooterData.pages[currentPage] &&
      tabHeaderFooterData.pages[currentPage].elements
    ) {
      setQuestionListSize(
        tabHeaderFooterData.pages[currentPage].elements.length
      );
    }
  }, [tabHeaderFooterData.pages, currentPage]);

  const getRandom = () => {
    const questionList = tabHeaderFooterData.pages.flatMap(
      (page) => page.elements
    );

    let highestId = 0;
    if (questionList.length > 0) {
      highestId = questionList.reduce((maxId, question) => {
        if (question.id > maxId) {
          return question.id;
        } else {
          return maxId;
        }
      }, 0);
    }

    const key = highestId > 0 ? highestId + 1 : 1;

    setRandom(key + 1);
    return key;
  };
  // Intercept tab change
  const handleTabChange = (e) => {
    if (isDLDirty) {
      dispatch(
        loadToaster({
          type: "warn",
          title: "Unsaved Display Logic",
          msg: "Please save display logic before switching.",
        })
      );
      return; // Prevent tab change
    }
    setActiveHeaderEditTab(e.index);
  };

  const handleTabChangePage = (e) => {
    if (isDLDirty) {
      dispatch(
        loadToaster({
          type: "warn",
          title: "Unsaved Display Logic",
          msg: "Please save display logic before switching.",
        })
      );
      return; // Prevent tab change
    }
    setActiveEditTab(e.index);
  };

  const getRandomOptionId = () => {
    const key = randomOptionId;
    setRandomOptionId(key + 1);
    return key;
  };

  const navigateToNewTab = () => {
    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith("survey_preview_")) {
        sessionStorage.removeItem(key);
      }
    });
    // 1. Generate unique key for each preview
    const previewId = `survey_preview_${Date.now()}`;

    // 2. Store data temporarily
    sessionStorage.setItem(
      previewId,
      JSON.stringify({
        data: tabHeaderFooterData,
        surveyId: currentSurveyID, // From Redux store
        surveyCode: currentCode, // From Redux store
      })
    );

    // 3. Pass only the reference ID
    window.open(`/preview?previewId=${previewId}`, "_blank");
  };

  const addNewQuestion = (questionType) => {
    if (isDLDirty) {
      dispatch(
        loadToaster({
          type: "warn",
          title: "Unsaved Display Logic",
          msg: "Please save display logic before switching.",
        })
      );
      return; // Prevent adding new question
    }
    setChanges((a) => a + 1);
    dispatch(checkOnCHangeData(true));

    let newQuestion = {};

    newQuestion.id = getRandom();
    newQuestion.tempId = "Q" + (currentPage + 1) + "-" + getRandom();
    newQuestion.type = questionType.questionType;
    newQuestion.typeId = questionType.id;
    newQuestion.questionText = "";
    newQuestion.questionDescription = "";
    newQuestion.questionSequence = getRandom();
    newQuestion.rateMax = 5;
    newQuestion.minValue = 18;
    newQuestion.maxValue = 99;
    newQuestion.selectedType = questionType;
    let j = getRandomOptionId();
    if (newQuestion.type === "selectList" || newQuestion.type === "ranking") {
      newQuestion.choices = [];
    } else if (newQuestion.type === "boolean") {
      newQuestion.labelTrue = "Yes";
      newQuestion.labelFalse = "No";
    } else if (newQuestion.type === "NPS") {
      newQuestion.minLabel = "Not at all likely";
      newQuestion.maxLabel = "Extremely likely";
    } else if (
      newQuestion.type === "matrix" ||
      newQuestion.type === "matrixmultiChoice"
    ) {
      newQuestion.rows = ["", ""];
      newQuestion.columns = ["", ""];
    } else if (newQuestion.type === "matrixOptionChoice") {
      newQuestion.rows = ["", ""];
      newQuestion.columns = ["", ""];
      newQuestion.cellOptions = ["", ""];
    } else if (newQuestion.type === "imagepicker") {
      newQuestion.choices = [
        { id: "", imageLink: "", value: "", tempId: j++ },
        { id: "", imageLink: "", value: "", tempId: j++ },
      ];
    } else {
      newQuestion.choices = [
        { id: "", text: "", value: "", tempId: j++ },
        { id: "", text: "", value: "", tempId: j++ },
      ];
    }
    setRandomOptionId(j);
    newQuestion.dateFormat = "dd/MM/yyyy";
    newQuestion.isMandatory = false;
    newQuestion.others = false;
    newQuestion.yesOrNo = false;
    newQuestion.choicesOrder = "normal";
    newQuestion.codedOption = false;
    newQuestion.requiredErrorText = "Answer cannot be empty";
    newQuestion.DLFormulaText = "";
    newQuestion.visibleIf = "";
    newQuestion.placeHolderText = "Type Here..";
    newQuestion.status = ADDED;
    newQuestion.errorStatus = true;
    newQuestion.option_pipeline = "";
    newQuestion.option_pipeline_type = "include";
    newQuestion.isOption = true;
    // newQuestion.projectId = projectId;
    setActiveQuestion({
      pageIndex: currentPage,
      questionIndex: questionListSize,
    });
    setActiveHeaderFooter(null);

    setTabHeaderFooterData((prevState) => {
      const updatedPages = prevState.pages.map((page, index) => {
        if (index === currentPage) {
          return {
            ...page,
            elements: [...page.elements, newQuestion],
          };
        }
        return page;
      });
      return {
        ...prevState,
        pages: updatedPages,
      };
    });
  };

  const matrixAddOption = React.useCallback(
    (index, type) => {
      const currentPageIndex = activeQuestion.pageIndex;
      const currentQuestionIndex = activeQuestion.questionIndex;

      if (currentPageIndex === null || currentQuestionIndex === null) {
        console.error("No active question selected");
        return;
      }

      dispatch(checkOnCHangeData(true));

      setTabHeaderFooterData((prevState) => {
        const pages = [...prevState.pages];
        const elements = [...pages[currentPageIndex].elements];
        const question = { ...elements[currentQuestionIndex] };

        // Add empty string at specified position
        question[type] = [
          ...question[type].slice(0, index),
          "",
          ...question[type].slice(index),
        ];

        // Update elements and pages
        elements[currentQuestionIndex] = question;
        pages[currentPageIndex] = {
          ...pages[currentPageIndex],
          elements: elements,
        };

        return {
          ...prevState,
          pages: pages,
        };
      });
    },
    [activeQuestion, dispatch]
  );
  const addOption = React.useCallback(
    (index) => {
      // Get current indices at the time of click to avoid stale closures
      const currentPageIndex = activeQuestion.pageIndex;
      const currentQuestionIndex = activeQuestion.questionIndex;

      if (currentPageIndex === null || currentQuestionIndex === null) {
        console.error("No active question selected");
        return;
      }

      setChanges((prev) => prev + 1);
      dispatch(checkOnCHangeData(true));

      setTabHeaderFooterData((prevState) => {
        const pages = [...prevState.pages];
        const elements = [...pages[currentPageIndex].elements];
        const question = { ...elements[currentQuestionIndex] };

        // Generate new option with unique tempId
        const newOption = {
          id: "",
          text: "",
          value: "",
          tempId: Date.now(),
        };

        // Insert new option at specified position
        question.choices = [
          ...question.choices.slice(0, index),
          newOption,
          ...question.choices.slice(index),
        ];

        // Update question status
        question.errorStatus = true;
        if (question.status !== ADDED) {
          question.status = UPDATED;
        }

        // Update elements and pages immutably
        elements[currentQuestionIndex] = question;
        pages[currentPageIndex] = {
          ...pages[currentPageIndex],
          elements: elements,
        };

        return {
          ...prevState,
          pages: pages,
        };
      });
    },
    [activeQuestion, dispatch]
  );
  const matrixRemoveOption = (index, type) => {
    setChanges((a) => a + 1);
    dispatch(checkOnCHangeData(true));

    let newQuestion = JSON.parse(
      JSON.stringify(
        tabHeaderFooterData.pages[activeQuestion.pageIndex].elements[
          activeQuestion.questionIndex
        ]
      )
    );

    newQuestion[type].splice(index, 1);
    if (newQuestion.status !== ADDED) newQuestion.status = UPDATED;

    setTabHeaderFooterData((prevState) => {
      const updatedPages = prevState.pages.map((page, pageIdx) => {
        if (pageIdx === activeQuestion.pageIndex) {
          const updatedElements = page.elements.map((ques, quesIdx) => {
            if (quesIdx === activeQuestion.questionIndex) return newQuestion;
            return ques;
          });
          return { ...page, elements: updatedElements };
        }
        return page;
      });
      return { ...prevState, pages: updatedPages };
    });
  };
  const removeOption = React.useCallback(
    (index) => {
      const currentPageIndex = activeQuestion.pageIndex;
      const currentQuestionIndex = activeQuestion.questionIndex;

      if (currentPageIndex === null || currentQuestionIndex === null) {
        console.error("No active question selected");
        return;
      }

      setChanges((prev) => prev + 1);
      dispatch(checkOnCHangeData(true));

      setTabHeaderFooterData((prevState) => {
        const pages = [...prevState.pages];
        const elements = [...pages[currentPageIndex].elements];
        const question = { ...elements[currentQuestionIndex] };

        // Remove option at specified index
        question.choices = [
          ...question.choices.slice(0, index),
          ...question.choices.slice(index + 1),
        ];

        // Update question status
        if (question.status !== ADDED) {
          question.status = UPDATED;
        }

        // Validate after removal
        const errors = validateQuestionsAndOptions(question);
        question.errorStatus = Object.keys(errors).length > 0;

        // Update elements and pages
        elements[currentQuestionIndex] = question;
        pages[currentPageIndex] = {
          ...pages[currentPageIndex],
          elements: elements,
        };

        return {
          ...prevState,
          pages: pages,
        };
      });
    },
    [activeQuestion, dispatch]
  );

  const addMultipleOptions = React.useCallback(
    (newOptions) => {
      const currentPageIndex = activeQuestion.pageIndex;
      const currentQuestionIndex = activeQuestion.questionIndex;

      if (currentPageIndex === null || currentQuestionIndex === null) {
        console.error("No active question selected");
        return;
      }

      setChanges((prev) => prev + 1);
      dispatch(checkOnCHangeData(true));

      setTabHeaderFooterData((prevState) => {
        const pages = [...prevState.pages];
        const elements = [...pages[currentPageIndex].elements];
        const question = { ...elements[currentQuestionIndex] };

        let j = randomOptionId;
        const newOptions2 = newOptions.map((option) => ({
          ...option,
          id: undefined,
          tempId: j++,
        }));

        question.choices = [
          ...question.choices.filter(
            (o) => (o.value ?? "").trim() !== "" || o.text !== ""
          ),
          ...newOptions2,
        ];

        // FIX: Run validation after adding options
        const errors = validateQuestionsAndOptions(question);
        question.errorStatus = Object.keys(errors).length > 0;

        if (question.status !== ADDED) {
          question.status = UPDATED;
        }

        elements[currentQuestionIndex] = question;
        pages[currentPageIndex] = {
          ...pages[currentPageIndex],
          elements: elements,
        };

        setRandomOptionId(j); // Update for next use

        return {
          ...prevState,
          pages: pages,
        };
      });
    },
    [activeQuestion, dispatch]
  );
  const onChange = (e, type, question, isSelect = false, optionfield = "") => {
    console.log(question);
    setChanges((a) => a + 1);
    dispatch(checkOnCHangeData(true));

    let newOption = undefined;
    let oldOption = undefined;

    let newQuestion = JSON.parse(JSON.stringify(question));

    if (type == "questionText") {
      e.preventDefault();
      newQuestion[type] = e.target.value;
    } else if (type == "questionDescription") {
      e.preventDefault();
      newQuestion[type] = e.target.value;
    } else if (type === "selectListOptions") {
      // let choices = e.target.value.replace(/\n(?!\s)/g, '');
      newQuestion.choices = [e.target.value];
    } else if (type === "options") {
      //console.log(question.choice,"Options");
      let options = JSON.parse(JSON.stringify(question.choices));

      newOption = e.target.value;
      oldOption = options[e.target.index][optionfield];
      options[e.target.index][optionfield] = e.target.value;
      if (!newQuestion.codedOption) {
        options[e.target.index].value = e.target.value;
      }

      newQuestion.choices = options;
    } else if (type === "imageOptions") {
      let options = JSON.parse(JSON.stringify(question.choices));
      newOption = e.target.value;
      oldOption = options[e.target.index][optionfield];
      options[e.target.index][optionfield] = e.target.value;
      newQuestion.choices = options;
    } else if (type === "booleanYesOptions") {
      newQuestion.labelTrue = e.target.value;
    } else if (type === "booleanNoOptions") {
      newQuestion.labelFalse = e.target.value;
    } else if (type === "isMandatory") {
      newQuestion[type] = e.value;
    } else if (type === "requiredErrorText") {
      newQuestion[type] = e.target.value;
    } else if (type === "choicesOrder") {
      newQuestion[type] = e;
    } else if (type === "webOptions") {
      newQuestion[type] = e;
    } else if (type === "mobileOptions") {
      newQuestion[type] = e;
    } else if (type === "placeHolderText") {
      newQuestion[type] = e.target.value;
    } else if (type === "maxValue") {
      newQuestion[type] = parseInt(e.target.value);
    } else if (type === "minValue") {
      newQuestion[type] = parseInt(e.target.value);
    } else if (type === "rateMax") {
      newQuestion[type] = e;
    } else if (type === "step") {
      newQuestion[type] = parseInt(e.target.value);
    } else if (type === "others") {
      newQuestion[type] = e.value;
    } else if (type === "otherNumber") {
      newQuestion[type] = parseInt(e.target.value);
    } else if (type === "none") {
      newQuestion[type] = e.value;
    } else if (type === "codedOption") {
      newQuestion[type] = e.value;
    } else if (type === "tempId") {
      newQuestion[type] = e.target.value;
    } else if (type === "minLabel") {
      newQuestion.minLabel = e.target.value;
    } else if (type === "maxLabel") {
      newQuestion.maxLabel = e.target.value;
    } else if (type === "option_pipeline") {
      newQuestion[type] = e;
    } else if (type === "option_pipeline_type") {
      newQuestion[type] = e;
      console.log(e)
    } else if (type === "isOption") {
      newQuestion[type] = e.value;  
      if (e.value === false) {
            newQuestion.choices = [];
            newQuestion.choicesOrder = "normal";
            //newQuestion.codedOption = false;
            newQuestion.others = false;
            newQuestion.none = false;
            newQuestion.otherNumber = 0;
        }
    }

    if (type === "others" && newQuestion.others === true) {
      //console.log("Adding Other Option",newQuestion);
      let j = getRandomOptionId();
      if (!newQuestion.choices.some((opt) => opt.optionType === OTHER)) {
        newQuestion.choices.push({
          id: "",
          text: "Other",
          value: "Other",
          tempId: j++,
          optionType: OTHER,
        });
        setRandomOptionId(j);
      }

      // newQuestion.none = false;
      setRandomOptionId(j);
    } else if (
      type === "otherNumber" &&
      newQuestion.otherNumber > 0 &&
      newQuestion.others === true
    ) {
      let j = getRandomOptionId();
      // Filter existing 'Other' options
      const otherOptions = newQuestion.choices.filter(
        (opt) => opt.optionType === OTHER
      );
      const otherCount = otherOptions.length;

      if (newQuestion.otherNumber > otherCount) {
        // Add missing 'Other' options
        const toAdd = newQuestion.otherNumber - otherCount;
        for (let i = 0; i < toAdd; i++) {
          newQuestion.choices.push({
            id: "",
            text: "Other",
            value: "Other",
            tempId: j++,
            optionType: OTHER,
          });
        }
        setRandomOptionId(j);
      } else if (newQuestion.otherNumber < otherCount) {
        // Remove extra 'Other' options
        let toRemove = otherCount - newQuestion.otherNumber;
        for (
          let i = newQuestion.choices.length - 1;
          i >= 0 && toRemove > 0;
          i--
        ) {
          if (newQuestion.choices[i].optionType === OTHER) {
            newQuestion.choices.splice(i, 1);
            toRemove--;
          }
        }
      }
    } else if (type === "others" && newQuestion.others === false) {
      oldOption = "Other";
      newQuestion.choices = newQuestion.choices.filter(
        (option) => option.optionType !== OTHER
      );
    } else if (type === "none" && newQuestion.none === true) {
      let j = getRandomOptionId();
      newQuestion.choices = newQuestion.choices.filter(
        (option) => option.optionType !== NONE
      );
      newQuestion.choices.push({
        id: "",
        text: "None",
        value: "None",
        tempId: j++,
        optionType: NONE,
      });
      setRandomOptionId(j);
    } else if (type === "none" && newQuestion.none === false) {
      oldOption = "None";
      newQuestion.choices = newQuestion.choices.filter(
        (option) => option.optionType !== NONE
      );
    }
    const errors = validateQuestionsAndOptions(newQuestion);
    setError(errors);
    newQuestion.errorStatus =
      errors && Object.keys(errors).length > 0 ? true : false;

    let newQuestionList = tabHeaderFooterData.pages[currentPage].elements.map(
      (ques, idx) => {
        if (ques.id === newQuestion.id) return newQuestion;

        return ques;
      }
    );
    setTabHeaderFooterData((prevState) => {
      const updatedPages = prevState.pages.map((page, index) => {
        if (index === currentPage) {
          return {
            ...page,
            elements: newQuestionList,
          };
        }
        return page;
      });
      //console.log(updatedPages,"updatedPages");
      return {
        ...prevState,
        pages: updatedPages,
      };
    });
  };
  const onDLChange = (e, type, question) => {
    setChangeDisplayLogic(true);
    dispatch(checkOnCHangeData(true));

    let newQuestion = JSON.parse(JSON.stringify(question));

    if (type === "DLFormulaText") {
      newQuestion[type] = e;
    }

    setTabHeaderFooterData((prevState) => {
      const updatedPages = prevState.pages.map((page, index) => {
        if (index === currentPage) {
          const updatedElements = page.elements.map((ques, idx) => {
            if (ques.tempId === newQuestion.tempId) {
              return newQuestion;
            }
            return ques;
          });
          return {
            ...page,
            elements: updatedElements,
          };
        }
        return page;
      });
      return {
        ...prevState,
        pages: updatedPages,
      };
    });
  };

  const saveDLForEachQuestion = (updatedQuestion) => {
    dispatch(checkOnCHangeData(false));

    setTabHeaderFooterData((prevState) => {
      const updatedPages = prevState.pages.map((page, index) => {
        if (index === currentPage) {
          const updatedElements = page.elements.map((ques, idx) => {
            if (ques.tempId === updatedQuestion.tempId) {
              return updatedQuestion;
            }
            return ques;
          });
          return {
            ...page,
            elements: updatedElements,
          };
        }
        return page;
      });
      return {
        ...prevState,
        pages: updatedPages,
      };
    });
  };
  const save = () => {
    const { status: isFine, msg } = validateAllQuestions(tabHeaderFooterData);
    if (isFine === false) {
      dispatch(
        loadToaster({ type: "warn", title: "Validation Failed", msg: msg })
      );
      return;
    }
    if (isDLDirty) {
      dispatch(
        loadToaster({
          type: "warn",
          title: "Validation Failed",
          msg: "Please validate display logic before saving.",
        })
      );
      return;
    }
    if (changeDisplayLogic) {
      dispatch(
        loadToaster({
          type: "warn",
          title: "Validation Failed",
          msg: "Please save the display logic changes",
        })
      );
      return;
    } else {
      tabHeaderFooterData.pages = tabHeaderFooterData.pages.map((page) => {
        const updatedElements = page.elements.map((element) => {
          if (
            element.selectedType.questionType === "selectList" ||
            element.selectedType.questionType === "ranking"
          ) {
            const updatedChoices = element.choices.map((choice) => {
              return choice.replace(/\s*,\s*/g, ",").replace(/\s*\n$/, "");
            });
            return {
              ...element,
              choices: updatedChoices,
            };
          }
          return element;
        });
        return {
          ...page,
          elements: updatedElements,
        };
      });
      let postObject = {
        survey_id: currentSurveyID,
        user_id: userLoginDetails.user_id,
        survey_definition: JSON.stringify(tabHeaderFooterData),
      };
      console.log("Post Object: ", tabHeaderFooterData);
      dispatch(createOrUpdateSurveyDefinition(postObject));
      dispatch(checkOnCHangeData(false));
    }
  };

  const toggleHeaderFooter = (value) => {
    if (isDLDirty) {
      dispatch(
        loadToaster({
          type: "warn",
          title: "Unsaved Display Logic",
          msg: "Please save display logic before switching.",
        })
      );
      return; // Prevent navigation
    }
    setActiveHeaderFooter(value);
    setActiveHeaderEditTab(0);
    setActiveQuestion({ pageIndex: -1, questionIndex: -1 });
  };

  const HeaderSettingsOnChange = (e, type, header) => {
    let updatedHeaderData = JSON.parse(
      JSON.stringify(tabHeaderFooterData.header)
    );
    dispatch(checkOnCHangeData(true));

    if (type === "surveyheadingForeground") {
      updatedHeaderData.surveyheadingForeground.color = `#${e.value}`;
    } else if (type === "surveyheadingBackgroundColor") {
      updatedHeaderData.surveyheadingBackground[
        "background-color"
      ] = `#${e.value}`;
    } else if (type === "logoPosition") {
      updatedHeaderData.logoPosition = e;
    }
    const errors = validateHeader(updatedHeaderData);
    setError(errors);
    updatedHeaderData.headerErrorStatus =
      errors && Object.keys(errors).length > 0 ? true : false;

    setTabHeaderFooterData((prevState) => ({
      ...prevState,
      header: updatedHeaderData,
    }));
  };
  const HeaderDetaisOnChange = (e, type, question) => {
    dispatch(checkOnCHangeData(true));

    let updatedHeaderData = JSON.parse(
      JSON.stringify(tabHeaderFooterData.header)
    );

    if (type === "title") {
      updatedHeaderData.title = e.target.value;
    } else if (type === "description") {
      updatedHeaderData.description = e.target.value;
    } else if (type === "logo") {
      updatedHeaderData.logo = e.target.value;
    }
    const errors = validateHeader(updatedHeaderData);
    setError(errors);
    updatedHeaderData.headerErrorStatus =
      errors && Object.keys(errors).length > 0 ? true : false;

    setTabHeaderFooterData((prevState) => ({
      ...prevState,
      header: updatedHeaderData,
    }));
  };

  const FooterSettingsOnChange = (e, type, question) => {
    let updatedFooterData = JSON.parse(
      JSON.stringify(tabHeaderFooterData.footer)
    );
    dispatch(checkOnCHangeData(true));

    if (type === "nextbuttonstyle") {
      updatedFooterData.nextbuttonstyle["background-color"] = `#${e.value}`;
    } else if (type === "footerBackgroundcolor") {
      updatedFooterData.footerBackgroundcolor = `#${e.value}`;
    } else if (type === "progressbar") {
      updatedFooterData.progressbar = e.target.value;
    } else if (type === "nextbuttonlabel") {
      updatedFooterData.nextbuttonlabel = e.target.value;
    } else if (type === "previousbuttonlabel") {
      updatedFooterData.previousbuttonlabel = e.target.value;
    } else if (type === "previousbuttonstyle") {
      updatedFooterData.previousbuttonstyle["background-color"] = `#${e.value}`;
    }
    const errors = validateFooter(updatedFooterData);
    setError(errors);
    updatedFooterData.footerErrorStatus =
      errors && Object.keys(errors).length > 0 ? true : false;

    setTabHeaderFooterData((prevState) => ({
      ...prevState,
      footer: updatedFooterData,
    }));
  };

  const addQuestionnaireList = (index) => {
    dispatch(checkOnCHangeData(true));

    setTabHeaderFooterData((prevState) => {
      let updatedPages = [...prevState.pages];

      // Ensure the new page is inserted at index + 1, shifting others down
      updatedPages.splice(index + 1, 0, { elements: [] });

      return {
        ...prevState,
        pages: updatedPages,
      };
    });
  };

  // const onNextPageClick = () => {
  //     setCurrentPage((prevState) => prevState + 1)
  // }
  // const onPreviousPageClick = () => {
  //     setCurrentPage((prevState) => prevState - 1)
  // }
  const onDeletePage = (pageIndex) => {
    setCurrentPage(pageIndex);
    setDeletePopUp(true);
  };

  const deletePage = () => {
    const updatedPages = [...tabHeaderFooterData.pages];

    // Remove the current page
    updatedPages.splice(currentPage, 1);

    // Check if mergeQuestions flag is true and the current page is not the first page
    if (mergeQuestions && currentPage > 0) {
      const previousPageQuestions = updatedPages[currentPage - 1].elements;
      const deletedPageQuestions =
        tabHeaderFooterData.pages[currentPage].elements;

      // Merge the questions of the deleted page with the previous page's questions
      updatedPages[currentPage - 1].elements =
        previousPageQuestions.concat(deletedPageQuestions);
    }

    setTabHeaderFooterData((prevState) => ({
      ...prevState,
      pages: updatedPages,
    }));

    setDeletePopUp(false);
    setCurrentPage((prevState) => prevState - 1);
    setMergeQuestions(false);
    dispatch(checkOnCHangeData(true));
  };
  const hideDialog = () => {
    setDeletePopUp(false);
    setMergeQuestions(false);
  };

  const showLanguageOrNavigateToTranslate = () => {
    if (isDLDirty) {
      dispatch(
        loadToaster({
          type: "warn",
          title: "Unsaved Display Logic",
          msg: "Please save display logic before switching.",
        })
      );
      return; // Prevent question change
    }
    dispatch(checkOnCHangeData(false));
    dispatch(displayTranlslationPage(true));
  };

  const renderFooter = () => {
    return (
      <div>
        <Button
          name="yes"
          label="Delete"
          icon="pi pi-check"
          onClick={deletePage}
        />
        <Button
          name="no"
          label="Cancel"
          icon="pi pi-times"
          onClick={hideDialog}
          className="p-button-secondary"
        />
      </div>
    );
  };

  const handleMergeCheckboxChange = (event) => {
    setMergeQuestions(event.checked);
  };
  // Clone functionality
  const cloneQuestion = (e, questionIndex, pageIndex = currentPage) => {
    e.stopPropagation();
    const targetPage =
      currentPage === null || currentPage === undefined
        ? pageIndex
        : currentPage;

    if (targetPage === null || targetPage === undefined) {
      console.error("Cannot clone question - no valid page context");
      return;
    }

    setCloneQuestionDialog({
      visible: true,
      questionIndex,
      pageIndex: targetPage,
    });
  };
  const confirmCloneQuestion = () => {
    const { questionIndex, pageIndex } = cloneQuestionDialog;

    if (pageIndex === null || questionIndex === null) return;

    setChanges((a) => a + 1);
    dispatch(checkOnCHangeData(true));

    const questionToClone =
      tabHeaderFooterData.pages[pageIndex]?.elements[questionIndex];

    if (!questionToClone) return;

    const newQuestion = JSON.parse(JSON.stringify(questionToClone));
    newQuestion.id = getRandom();
    newQuestion.tempId = "Q" + (pageIndex + 1) + "-" + getRandom();
    newQuestion.status = ADDED;
    newQuestion.questionSequence = questionToClone.questionSequence + 1;

    setTabHeaderFooterData((prevState) => {
      const updatedPages = prevState.pages.map((page, idx) => {
        if (idx === pageIndex) {
          return {
            ...page,
            elements: [
              ...page.elements.slice(0, questionIndex + 1),
              newQuestion,
              ...page.elements.slice(questionIndex + 1),
            ],
          };
        }
        return page;
      });
      return { ...prevState, pages: updatedPages };
    });

    setActiveQuestion({
      pageIndex,
      questionIndex: questionIndex + 1,
    });
    setCloneQuestionDialog({
      visible: false,
      questionIndex: null,
      pageIndex: null,
    });
  };
  const remove = (e, questionIndex, pageIndex = currentPage) => {
    e.stopPropagation();

    // If currentPage is undefined, use the pageIndex from the question
    const targetPage =
      currentPage === null || currentPage === undefined
        ? pageIndex
        : currentPage;

    setDeleteQuestionDialog({
      visible: true,
      questionIndex,
      pageIndex: targetPage,
    });
  };

  // Delete functionality
  const confirmDeleteQuestion = () => {
    const { questionIndex, pageIndex } = deleteQuestionDialog;

    if (pageIndex === null || questionIndex === null) return;

    setChanges((a) => a + 1);
    dispatch(checkOnCHangeData(true));

    const deletedQuestion =
      tabHeaderFooterData.pages[pageIndex].elements[questionIndex];
    const deletedQuestionTempId = deletedQuestion.tempId;

    const updatedPages = tabHeaderFooterData.pages.map((page) => {
      const updatedElements = page.elements
        .filter((question) => question.tempId !== deletedQuestionTempId)
        .map((question) => {
          if (question.visibleIf.includes(deletedQuestionTempId)) {
            question.visibleIf = "";
          }
          if (question.DLFormulaText.includes(deletedQuestionTempId)) {
            question.DLFormulaText = "";
          }
          return question;
        });

      return { ...page, elements: updatedElements };
    });

    let updatedActiveQuestion = { ...activeQuestion };

    if (activeQuestion.pageIndex === pageIndex) {
      if (activeQuestion.questionIndex > 0) {
        if (
          activeQuestion.questionIndex === questionIndex ||
          activeQuestion.questionIndex !== questionListSize
        ) {
          updatedActiveQuestion.questionIndex =
            activeQuestion.questionIndex - 1;
        } else if (activeQuestion.questionIndex === questionListSize) {
          updatedActiveQuestion.questionIndex = questionListSize - 2;
        }
      }
    }

    setTabHeaderFooterData((prevState) => ({
      ...prevState,
      pages: updatedPages,
    }));

    setActiveQuestion(updatedActiveQuestion);
    setDeleteQuestionDialog({
      visible: false,
      questionIndex: null,
      pageIndex: null,
    });
  };

  const getActiveElementType = () => {
    if (activeHeaderFooter === "header") return "Header";
    if (activeHeaderFooter === "footer") return "Footer";
    if (currentPage !== null && activeQuestion.questionIndex >= 0) {
      return (
        tabHeaderFooterData.pages[currentPage]?.elements[
          activeQuestion.questionIndex
        ]?.selectedType?.label || "Question"
      );
    }
    return currentPage !== null ? `Page ${currentPage + 1}` : "";
  };

  //Drag-Drop functionality
  const moveQuestion = useCallback(
    (dragPageIndex, dragIndex, hoverPageIndex, hoverIndex) => {
      // Validate indices
      if (
        dragPageIndex === undefined ||
        dragIndex === undefined ||
        hoverPageIndex === undefined ||
        hoverIndex === undefined
      ) {
        console.error("Invalid drag indices");
        return;
      }

      // No change if dropped in the same position
      if (dragPageIndex === hoverPageIndex && dragIndex === hoverIndex) return;

      setChanges((prev) => prev + 1);
      dispatch(checkOnCHangeData(true));

      setTabHeaderFooterData((prevState) => {
        try {
          if (
            !prevState.pages ||
            !prevState.pages[dragPageIndex]?.elements ||
            !prevState.pages[hoverPageIndex]?.elements
          ) {
            throw new Error("Invalid page structure");
          }

          // Deep clone to avoid direct state mutation
          const newPages = JSON.parse(JSON.stringify(prevState.pages));

          // Remove the dragged question from its original position
          const [movedQuestion] = newPages[dragPageIndex].elements.splice(
            dragIndex,
            1
          );

          if (!movedQuestion) {
            throw new Error("No question found at drag position");
          }

          // Insert into the new position (without changing ID/tempId)
          newPages[hoverPageIndex].elements.splice(
            hoverIndex,
            0,
            movedQuestion
          );

          // Update questionSequence to reflect new order (optional)
          newPages[hoverPageIndex].elements.forEach((question, idx) => {
            question.questionSequence = idx + 1;
          });

          return { ...prevState, pages: newPages };
        } catch (error) {
          console.error("Drag and drop error:", error);
          return prevState; // Return unchanged state on error
        }
      });

      // Update active question and current page
      setActiveQuestion({
        pageIndex: hoverPageIndex,
        questionIndex: hoverIndex,
      });
      setCurrentPage(hoverPageIndex);
    },
    [tabHeaderFooterData.pages]
  );
  const hideQuestion = (pageIndex, questionIndex, hideAction = true) => {
    // pageIndex / questionIndex come from Question component
    setHideQuestionDialog({
      visible: true,
      pageIndex,
      questionIndex,
      hideAction,
    });
  };

  const confirmHideQuestion = () => {
    const { pageIndex, questionIndex, hideAction } = hideQuestionDialog;
    if (pageIndex === null || questionIndex === null) {
      setHideQuestionDialog({
        visible: false,
        pageIndex: null,
        questionIndex: null,
        hideAction: true,
      });
      return;
    }

    setChanges((a) => a + 1);
    dispatch(checkOnCHangeData(true));

    setTabHeaderFooterData((prevState) => {
      const updatedPages = prevState.pages.map((page, pIdx) => {
        if (pIdx === pageIndex) {
          const updatedElements = page.elements.map((q, qIdx) => {
            if (qIdx === questionIndex) {
              const updatedQ = { ...q, isHide: hideAction };
              if (updatedQ.status !== ADDED) updatedQ.status = UPDATED;
              return updatedQ;
            }
            return q;
          });
          return { ...page, elements: updatedElements };
        }
        return page;
      });
      return { ...prevState, pages: updatedPages };
    });

    setHideQuestionDialog({
      visible: false,
      pageIndex: null,
      questionIndex: null,
      hideAction: true,
    });
  };
  return (
    <div
      style={{
        // border: '1px solid #d3caca',
        // borderRadius: '10px',
        margin: "5px",
      }}
    >
      <PageRefreshDialog />
      <div className="d-flex justify-content-between py-3">
        <div className="col-md-auto">
          <div
            className="row align-items-center"
            style={{ fontWeight: "bold", margin: 0, marginLeft: "4px" }}
          >
            <div className="col-md-auto" style={{ padding: "0px" }}>
              <span>
                {currentCode} |<span>{currentSurveyName}</span>
              </span>
            </div>
          </div>
        </div>
        <div
          className="d-flex flex-wrap gap-2 justify-content-md-end justify-content-center"
          style={{ textAlign: "right" }}
        >
          {/* 
                    <Button
                        name="Languages"
                        label="Languages"
                        className="custom-dashboard-primary-button"
                        icon="fa fa-language fa-fw"
                        style={{ backgroundColor: '#1F3BB3', fontSize: '12px', padding: '5px 4px', width: '120px' }}
                        onClick={showLanguageDialog}
                    /> */}
          {surveyDefinitionData &&
            surveyDefinitionData?.translations?.languages.length > 1 && (
              <Button
                name="Translate"
                label="Add Tranlation"
                className="p-button-primary"
                icon="fas fa-comment"
                style={{
                  backgroundColor: "#1F3BB3",
                  fontSize: "12px",
                  padding: "6px 5px",
                }}
                onClick={showLanguageOrNavigateToTranslate}
              />
            )}

          <Button
            name="Preview"
            label="Preview"
            className="p-button-warning"
            icon="pi pi-eye"
            style={{
              backgroundColor: "#1F3BB3",
              fontSize: "12px",
              padding: "6px 5px",
            }}
            onClick={navigateToNewTab}
          />
          <Button
            name="Json View"
            label="Json View"
            //className="p-button-warning"
            icon="pi pi-eye"
            style={{
              backgroundColor: "#008080",
              fontSize: "12px",
              padding: "6px 5px",
            }}
            onClick={() => {
              //const pagesData = tabHeaderFooterData.pages || [];
              setJsonData(JSON.stringify({ tabHeaderFooterData }, null, 2));
              setShowJsonModal(true);
            }}
          />
          <Button
            name="Save"
            label="Save"
            className="p-button-success"
            icon="pi pi-save"
            style={{
              backgroundColor: "#68b828",
              fontSize: "12px",
              padding: "6px 6px",
            }}
            onClick={save}
          />
        </div>
      </div>

      <div
        className="row"
        style={{
          margin: "5px",
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        {/* Questionnaire Section */}
        <div
          className="survey-sidebar d-flex flex-column border rounded bg-white"
          style={{
            flex: "2.5",
            overflow: "hidden",
            //maxHeight: 'calc(100vh - 100px)'
          }}
        >
          <div
            className="row question-header"
            style={{
              textAlign: "center",
              position: "sticky",
              top: 0,
              background: "white",
              zIndex: 10,
              padding: "5px",
              fontWeight: "bold",
              borderBottom: "1px solid #ddd",
            }}
          >
            Questionnaire
          </div>

          <div
            className="question-list-container"
            style={{
              //flex: 1,  /* Takes remaining space */
              overflowY: "auto",
              overflowX: "hidden",
              maxHeight: "calc(100vh - 140px)" /* Adjust this if needed */,
            }}
          >
            <div
              className={`row mt-2 question survey-question-header ${
                activeHeaderFooter === "header" ? "active" : ""
              }`}
              style={{
                position: "sticky",
                top: "2px", // height of "Questionnaire" bar + small margin
                zIndex: 11,
              }}
            >
              <div
                className="question-text mt-1"
                onClick={() => toggleHeaderFooter("header")}
                style={{
                  backgroundColor:
                    activeHeaderFooter === "header" ? "#0098f3" : "transparent",
                  color: activeHeaderFooter === "header" ? "#fff" : "#000",
                }}
              >
                {tabHeaderFooterData?.header?.headerErrorStatus &&
                tabHeaderFooterData?.header?.headerErrorStatus === true ? (
                  <i className="fa fa-exclamation-circle"></i>
                ) : (
                  <></>
                )}
                Survey Header
              </div>
            </div>

            <DndProvider backend={HTML5Backend}>
              {tabHeaderFooterData.pages?.map((page, pageIndex) => (
                <div
                  key={pageIndex}
                  style={{
                    marginBottom: "5px",
                    padding: "5px",
                    borderRadius: "5px",
                    backgroundColor: "#fff",
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                    border:
                      currentPage === pageIndex
                        ? "2px solid #1890ff"
                        : "1px solid #ddd",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px",
                      backgroundColor:
                        currentPage === pageIndex ? "#e6f7ff" : "#f8f9fa",
                      borderRadius: "5px",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <span
                      style={{
                        flexGrow: 1,
                        cursor: "pointer",
                        fontWeight:
                          currentPage === pageIndex ? "bold" : "normal",
                      }}
                      onClick={() => {
                        setCurrentPage(pageIndex);
                        setActiveQuestion({ pageIndex: -1, questionIndex: -1 }); // Clear question selection
                        setActiveHeaderFooter(null); // Clear header/footer selection
                      }}
                    >
                      Page {pageIndex + 1} / {tabHeaderFooterData.pages.length}
                    </span>

                    {currentPage === pageIndex && (
                      <i
                        className="fa fa-plus"
                        style={{
                          cursor: "pointer",
                          color: "#52c41a",
                          marginRight: "10px",
                        }}
                        onClick={() => addQuestionnaireList(pageIndex)}
                      />
                    )}
                    {pageIndex !== 0 && (
                      <i
                        className="fa-regular fa-trash-can"
                        style={{
                          cursor: "pointer",

                          color: "#ff4d4f",
                        }}
                        onClick={() => onDeletePage(pageIndex)}
                      />
                    )}
                  </div>

                  {/* REMOVED THE CONDITIONAL RENDERING - ALWAYS SHOW QUESTIONS */}
                  <QuestionsList
                    questions={page.elements}
                    onClick={handleQuestionClick}
                    clone={cloneQuestion}
                    selected={activeQuestion}
                    setActiveHeaderFooter={setActiveHeaderFooter}
                    remove={remove}
                    moveQuestion={moveQuestion}
                    hideQuestion={hideQuestion}
                    currentPage={pageIndex}
                  />
                </div>
              ))}
            </DndProvider>

            <div>
              <div
                className={`row question survey-question-header ${
                  activeHeaderFooter === "footer" ? "active" : ""
                }`}
              >
                <div
                  className="question-text"
                  onClick={() => toggleHeaderFooter("footer")}
                  style={{
                    backgroundColor:
                      activeHeaderFooter === "footer"
                        ? "#0098f3"
                        : "transparent",
                    color: activeHeaderFooter === "footer" ? "#fff" : "#000",
                  }}
                >
                  {" "}
                  {tabHeaderFooterData?.footer?.footerErrorStatus &&
                  tabHeaderFooterData?.footer?.footerErrorStatus === true ? (
                    <i className="fa fa-exclamation-circle"></i>
                  ) : (
                    <></>
                  )}
                  Survey Footer
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Main Content Section */}
        <div
          className="survey-content"
          style={{
            flex: "7.7",
            backgroundColor: "white",
            color: "black",
            border: "1px solid #d3caca",
            borderRadius: "10px",
            overflow: "hidden",
            //maxHeight: 'calc(100vh - 100px)',
            padding: "0px !important",
            position: "relative",
          }}
        >
          <div
            className="d-flex justify-content-end"
            style={{
              position: "absolute",
              top: "10px",
              right: "20px",
              zIndex: "1",
            }}
          >
            {getActiveElementType()}
          </div>
          {tabHeaderFooterData.pages &&
            (activeHeaderFooter === "header" ? (
              <TabView
                activeIndex={activeHeaderEditTab}
                onTabChange={handleTabChange}
              >
                <TabPanel header="Details">
                  <DetailsContent
                    dataContent={tabHeaderFooterData?.header}
                    onChange={HeaderDetaisOnChange}
                    error={error}
                    setError={setError}
                  />
                </TabPanel>
                <TabPanel header="Settings">
                  <SettingsContent
                    dataContent={tabHeaderFooterData.header}
                    onChange={HeaderSettingsOnChange}
                  />
                </TabPanel>
              </TabView>
            ) : activeHeaderFooter === "footer" ? (
              <TabView
                activeIndex={activeHeaderEditTab}
                onTabChange={handleTabChange}
              >
                <TabPanel header="Settings">
                  <FooterSettings
                    dataContent={tabHeaderFooterData.footer}
                    onChange={FooterSettingsOnChange}
                    error={error}
                    setError={setError}
                  />
                </TabPanel>
              </TabView>
            ) : (
              <>
                <TabView
                  activeIndex={activeEditTab}
                  onTabChange={handleTabChangePage}
                >
                  <TabPanel header="Details">
                    <div className="question-list-container">
                      {activeQuestion.pageIndex === currentPage && (
                        <Content
                          question={
                            tabHeaderFooterData.pages[activeQuestion.pageIndex]
                              ?.elements[activeQuestion.questionIndex]
                          }
                          onChange={onChange}
                          addOption={addOption}
                          matrixAddOption={matrixAddOption}
                          addMultipleOptions={addMultipleOptions}
                          removeOption={removeOption}
                          matrixRemoveOption={matrixRemoveOption}
                          error={error}
                          setError={setError}
                        />
                      )}
                    </div>
                  </TabPanel>
                  <TabPanel header="Settings">
                    <div className="question-list-container">
                      <Settings
                        question={
                          tabHeaderFooterData.pages[activeQuestion.pageIndex]
                            ?.elements[activeQuestion.questionIndex]
                        }
                        questionList={tabHeaderFooterData.pages || []}
                        onChange={onChange}
                      />
                    </div>
                  </TabPanel>
                  <TabPanel header="Display logic">
                    <div className="question-list-container">
                      <DisplayLogic
                        question={
                          tabHeaderFooterData.pages[activeQuestion.pageIndex]
                            ?.elements[activeQuestion.questionIndex]
                        }
                        questionList={tabHeaderFooterData.pages}
                        onChange={onDLChange}
                        currentPage={currentPage}
                        saveDLForEachQuestion={saveDLForEachQuestion}
                        activeQuestion={activeQuestion}
                        onDLDirtyChange={handleDLDirtyChange}
                      />
                    </div>
                  </TabPanel>
                  {["radiogroup", "checkbox"].includes(
                    tabHeaderFooterData.pages[activeQuestion.pageIndex]
                      ?.elements[activeQuestion.questionIndex]?.type
                  ) && (
                    <TabPanel header="Termination Logic">
                      <div className="question-list-container">
                        <TerminationLogic
                          question={
                            tabHeaderFooterData.pages[activeQuestion.pageIndex]
                              ?.elements[activeQuestion.questionIndex]
                          }
                          onChange={(terminateLogic) => {
                            // Update the question with termination logic
                            const updatedPages = [...tabHeaderFooterData.pages];
                            updatedPages[activeQuestion.pageIndex].elements[
                              activeQuestion.questionIndex
                            ] = {
                              ...updatedPages[activeQuestion.pageIndex]
                                .elements[activeQuestion.questionIndex],
                              terminateLogic,
                            };
                            console.log(
                              "Updated Pages with Termination Logic: ",
                              updatedPages
                            );
                            setTabHeaderFooterData({
                              ...tabHeaderFooterData,
                              pages: updatedPages,
                            });
                          }}
                        />
                      </div>
                    </TabPanel>
                  )}
                </TabView>
              </>
            ))}
        </div>

        {/* Add Question Section */}
        <div
          className="survey-sidebar"
          style={{
            flex: "1.8",
            border: "1px solid #d3caca",
            borderRadius: "10px",
            backgroundColor: "white",
            color: "black",
            overflowY: "hidden",
            overflowX: "hidden",
            //maxHeight: 'calc(100vh - 100px)',

            padding: "0px",
          }}
        >
          <div
            className="row question-header"
            style={{
              textAlign: "center",
              position: "sticky",
              top: 0,
              background: "white",
              zIndex: 10,
              padding: "5px",
              fontWeight: "bold",
              borderBottom: "1px solid #ddd",
            }}
          >
            Add Question
          </div>
          <div
            className="question-list-container"
            style={{
              //flex: 1,  /* Takes remaining space */
              overflowY: "auto",
              overflowX: "hidden",
              maxHeight: "calc(100vh - 140px)" /* Adjust this if needed */,
            }}
          >
            <QuestionTypeList onClick={addNewQuestion} />
          </div>
        </div>
      </div>

      <Dialog
        header="Confirmation Required"
        visible={deletePopUp}
        style={{ width: "40vw" }}
        onHide={hideDialog}
        footer={renderFooter()}
        contentStyle={{ height: "90px" }}
      >
        <div className="container">
          <p className="text-start">
            You cannot undo this action.{" "}
            <b>Are you sure you want to proceed?</b>
          </p>
          <div className="d-flex align-items-center justify-content-start">
            <Checkbox
              id="mergeCheckbox"
              onChange={handleMergeCheckboxChange}
              checked={mergeQuestions}
            />
            <label
              style={{ marginLeft: "10px", marginBottom: 0 }}
              htmlFor="mergeCheckbox"
            >
              {`Do you want to merge these questions on page ${currentPage}?`}
            </label>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="JSON View"
        visible={showJsonModal}
        style={{ width: "45vw" }}
        onHide={() => setShowJsonModal(false)}
        footer={
          <div>
            <Button
              label="Copy"
              icon="pi pi-copy"
              onClick={() => navigator.clipboard.writeText(jsonData)}
              style={{ fontSize: "12px", padding: "6px 6px" }}
            />
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={() => setShowJsonModal(false)}
              className="p-button-secondary"
              style={{ fontSize: "12px", padding: "6px 6px" }}
            />
          </div>
        }
      >
        <div
          style={{
            maxHeight: "60vh", // vertical scrolling within this box
            overflowX: "scroll", // always show horizontal scrollbar
            overflowY: "scroll", // vertical scrolling if needed
            whiteSpace: "pre", // keep formatting
          }}
        >
          <pre style={{ margin: 0, minWidth: "100%", overflow: "visible" }}>
            {jsonData}
          </pre>
        </div>
      </Dialog>

      <Dialog
        header="Clone Question"
        visible={cloneQuestionDialog.visible}
        style={{ width: "40vw" }}
        onHide={() =>
          setCloneQuestionDialog({
            visible: false,
            questionIndex: null,
            pageIndex: null,
          })
        }
        footer={
          <div>
            <Button
              label="Save"
              icon="pi pi-check"
              onClick={confirmCloneQuestion}
              style={{ fontSize: "12px", padding: "6px 6px" }}
            />
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={() =>
                setCloneQuestionDialog({
                  visible: false,
                  questionIndex: null,
                  pageIndex: null,
                })
              }
              className="p-button-secondary"
              style={{ fontSize: "12px", padding: "6px 6px" }}
            />
          </div>
        }
      >
        <p>Are you sure you want to clone this question?</p>
      </Dialog>

      <Dialog
        header="Delete Question"
        visible={deleteQuestionDialog.visible}
        style={{ width: "40vw" }}
        onHide={() =>
          setDeleteQuestionDialog({
            visible: false,
            questionIndex: null,
            pageIndex: null,
          })
        }
        footer={
          <div>
            <Button
              label="Delete"
              icon="pi pi-trash"
              onClick={confirmDeleteQuestion}
              className="p-button-danger"
              style={{ fontSize: "12px", padding: "6px 6px" }}
            />
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={() =>
                setDeleteQuestionDialog({
                  visible: false,
                  questionIndex: null,
                  pageIndex: null,
                })
              }
              className="p-button-secondary"
              style={{ fontSize: "12px", padding: "6px 6px" }}
            />
          </div>
        }
      >
        <p>
          Are you sure you want to delete this question? This action cannot be
          undone.
        </p>
      </Dialog>

      <Dialog
        header={
          hideQuestionDialog.hideAction ? "Hide Question" : "Unhide Question"
        }
        visible={hideQuestionDialog.visible}
        style={{ width: "40vw" }}
        onHide={() =>
          setHideQuestionDialog({
            visible: false,
            pageIndex: null,
            questionIndex: null,
            hideAction: true,
          })
        }
        footer={
          <div>
            <Button
              label={hideQuestionDialog.hideAction ? "Hide" : "Unhide"}
              icon={
                hideQuestionDialog.hideAction ? "pi pi-eye-slash" : "pi pi-eye"
              }
              onClick={confirmHideQuestion}
              style={{ fontSize: "12px", padding: "6px 6px" }}
            />
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={() =>
                setHideQuestionDialog({
                  visible: false,
                  pageIndex: null,
                  questionIndex: null,
                  hideAction: true,
                })
              }
              className="p-button-secondary"
              style={{ fontSize: "12px", padding: "6px 6px" }}
            />
          </div>
        }
      >
        <div className="container">
          <p className="text-start">
            {hideQuestionDialog.hideAction
              ? "Are you sure you want to hide this question? Hidden questions are not shown in survey."
              : "Are you sure you want to unhide this question? It will become visible in survey again."}
          </p>
        </div>
      </Dialog>
    </div>
  );
};

export default Design;
